import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import usePageMeta from "@/hooks/usePageMeta";

const scopeProvided = [
  "日韩地区情感类电影的条目整理：片名、年份、地区、片长、导演与主演信息",
  "剧情简介与创作背景的文字介绍，帮助观众判断是否符合自己的口味",
  "按年代、地区、片长与题材标签组合的多维筛选与关键词检索",
  "影视资讯：片单前瞻、行业观察、幕后访谈与修复重映动态",
];

const scopeNotProvided = [
  "任何形式的在线播放、视频嵌入或播放器功能",
  "任何下载链接、网盘地址或资源分发服务",
  "付费观看、会员购买或任何形式的交易",
  "真实用户账号体系与观看记录存储",
];

export default function AboutPage() {
  usePageMeta(
    "关于我们 - 日韩黄色电影平台",
    "了解日韩黄色电影平台的定位与内容范围：我们整理日韩情色电影的条目信息、剧情简介与影视资讯，不提供任何播放与下载资源。",
    "日韩黄色电影,关于我们,日韩情色电影,影视资料站",
  );

  return (
    <SiteLayout>
      <div className="w-full bg-background-50">
        <section className="w-full px-4 md:px-6 pt-10 md:pt-16 pb-10 md:pb-14 border-b border-background-300/60">
          <div className="w-full max-w-[1200px] mx-auto">
            <nav className="flex items-center gap-1.5 text-[11px] md:text-xs text-foreground-500">
              <Link to="/" className="hover:text-accent-500 transition-colors cursor-pointer">
                首页
              </Link>
              <i className="ri-arrow-right-s-line" />
              <span className="text-accent-500">关于本站</span>
            </nav>

            <div className="mt-6 grid grid-cols-1 lg:grid-cols-[1.2fr_0.8fr] gap-8 lg:gap-12 items-center">
              <div className="min-w-0">
                <p className="font-label text-[11px] tracking-[0.26em] uppercase text-accent-500">
                  About the Archive
                </p>
                <h1 className="mt-3 font-heading text-3xl md:text-5xl leading-tight text-foreground-950">
                  关于日韩黄色电影
                </h1>
                <p className="mt-5 text-sm md:text-[15px] leading-[1.95] text-foreground-600">
                  日韩黄色电影是一个面向成年观众的日韩情色影视资料站。我们不做资源分发，
                  而是把注意力放在「整理」这件事上：为每一部作品建立条目，记录它的年份、地区、
                  片长、导演、演员与题材，用尽量克制的文字描述剧情，并把它放进合适的片单里。
                </p>
                <p className="mt-3 text-sm md:text-[15px] leading-[1.95] text-foreground-600">
                  站内目前收录 20 部演示影片、8 篇资讯与 6 个分类专题。所有影片、影人与资讯均为
                  虚构的演示内容，用于展示站点的信息结构与浏览体验。
                </p>
                <div className="mt-6 flex flex-wrap gap-3">
                  <Link
                    to="/category/popular"
                    className="h-11 px-6 rounded-md bg-primary-500 text-foreground-950 text-sm flex items-center gap-2 cursor-pointer hover:bg-primary-600 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-compass-3-line" />
                    进入片库
                  </Link>
                  <Link
                    to="/faq"
                    className="h-11 px-6 rounded-md border border-background-400/60 text-foreground-800 text-sm flex items-center gap-2 cursor-pointer hover:border-accent-500 hover:text-accent-500 transition-colors whitespace-nowrap"
                  >
                    常见问题
                    <i className="ri-arrow-right-line" />
                  </Link>
                </div>
              </div>

              <div className="w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-200 border border-background-300/60">
                <img
                  src="https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20dark%20vintage%20film%20archive%20room%2C%20wooden%20shelves%20of%20film%20canisters%2C%20warm%20amber%20desk%20lamp%20and%20deep%20crimson%20curtain%2C%20quiet%20atmospheric%20magazine%20photography%2C%20no%20text&width=800&height=600&seq=about-visual-01&orientation=landscape"
                  alt="影视资料整理场景示意图"
                  title="日韩黄色电影影视资料站"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16">
          <div className="w-full max-w-[1200px] mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">内容范围</h2>
            <p className="mt-2 text-xs md:text-sm text-foreground-500 max-w-[680px] leading-relaxed">
              为了避免误解，这里明确列出我们在做什么、以及我们不做的事。
            </p>

            <div className="mt-7 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
              <div className="rounded-lg border border-background-300/60 bg-background-100 p-5 md:p-6">
                <h3 className="flex items-center gap-2 text-sm text-foreground-900">
                  <span className="w-7 h-7 rounded-md bg-primary-500/10 text-primary-700 flex items-center justify-center">
                    <i className="ri-check-line" />
                  </span>
                  我们提供
                </h3>
                <ul className="mt-4 space-y-3">
                  {scopeProvided.map((item) => (
                    <li key={item} className="flex items-start gap-2.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                      <i className="ri-checkbox-circle-line mt-0.5 text-primary-700 shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rounded-lg border border-background-300/60 bg-background-100 p-5 md:p-6">
                <h3 className="flex items-center gap-2 text-sm text-foreground-900">
                  <span className="w-7 h-7 rounded-md bg-background-200 text-foreground-600 flex items-center justify-center">
                    <i className="ri-close-line" />
                  </span>
                  我们不提供
                </h3>
                <ul className="mt-4 space-y-3">
                  {scopeNotProvided.map((item) => (
                    <li key={item} className="flex items-start gap-2.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                      <i className="ri-close-circle-line mt-0.5 text-foreground-400 shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100 border-y border-background-300/60">
          <div className="w-full max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
            <div className="min-w-0">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">使用须知</h2>
              <div className="mt-5 space-y-4">
                {[
                  {
                    title: "仅限成年用户",
                    text: "本站内容面向 18 岁以上的成年用户。若你未满法定年龄，请立即离开。",
                  },
                  {
                    title: "演示内容声明",
                    text: "站内影片、导演、演员与资讯均为虚构示例，若与现实作品雷同纯属巧合。",
                  },
                  {
                    title: "无播放与下载",
                    text: "本站不托管任何视频文件，也不提供任何形式的资源获取途径。",
                  },
                  {
                    title: "尊重版权",
                    text: "如需观看真实作品，请通过正规影院、流媒体平台或发行方渠道获取授权内容。",
                  },
                ].map((item) => (
                  <div key={item.title} className="flex gap-3">
                    <span className="mt-0.5 w-1.5 h-1.5 rounded-full bg-accent-500 shrink-0" />
                    <div className="min-w-0">
                      <h3 className="text-sm text-foreground-900">{item.title}</h3>
                      <p className="mt-1 text-xs md:text-sm leading-relaxed text-foreground-500">
                        {item.text}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="min-w-0">
              <div className="rounded-lg border border-background-300/60 bg-background-50 p-5 md:p-7">
                <h2 className="font-heading text-2xl text-foreground-950">联系我们</h2>
                <p className="mt-3 text-xs md:text-sm leading-relaxed text-foreground-500">
                  如果你对条目信息有疑问，或希望指出内容错误、提出合作与建议，欢迎通过邮件联系。
                  我们会尽量在三个工作日内回复。
                </p>

                <a
                  href="mailto:contact@jkcinema-demo.com"
                  className="mt-5 flex items-center justify-between gap-3 px-4 py-3.5 rounded-md bg-background-100 border border-background-300/60 hover:border-accent-500 transition-colors cursor-pointer group"
                >
                  <span className="flex items-center gap-3 min-w-0">
                    <span className="w-9 h-9 rounded-md bg-primary-500/10 text-primary-700 flex items-center justify-center shrink-0">
                      <i className="ri-mail-line" />
                    </span>
                    <span className="min-w-0">
                      <span className="block text-[10px] tracking-widest uppercase text-foreground-400">
                        Email
                      </span>
                      <span className="block text-sm text-foreground-800 truncate group-hover:text-accent-500 transition-colors">
                        contact@jkcinema-demo.com
                      </span>
                    </span>
                  </span>
                  <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-accent-500 transition-colors" />
                </a>

                <div className="mt-5 pt-5 border-t border-background-300/60 flex items-center justify-between text-[11px] text-foreground-400">
                  <span>内容更正 / 版权问题</span>
                  <span>工作日 10:00 - 18:00</span>
                </div>
              </div>

              <div className="mt-4 rounded-lg border border-primary-500/30 bg-primary-500/10 p-4">
                <p className="text-[11px] leading-relaxed text-foreground-500">
                  <i className="ri-shield-check-line mr-1.5 text-primary-700" />
                  本页面为演示站点，邮箱地址与联系方式均为示例信息，不会真实接收邮件。
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </SiteLayout>
  );
}